import { storeChecklistReqDto } from './store-checklist.req.dto';
import { z } from 'zod';

export const storeChecklistResDto = storeChecklistReqDto;
export type StoreChecklistResDto = z.infer<typeof storeChecklistResDto>;
